module.exports = __webpack_public_path__ + "img/structuraldrawing1.00b0b2b2.png";